<div class="body">
    <router-outlet></router-outlet>
</div>